<template>
  <div>
    <div class="tab" v-if="!currentExamResult">
      <div class="tab__header">
        <router-link to="/pdd/exams" class="come-back">Назад к списку экзаменов</router-link>
        <div class="h2 tab__title">Экзамен {{ examName }}</div>
        <div class="timer">{{ timeFromSeconds }}</div>
      </div>

      <div class="tab__question">
        <div class="sly-wrap">
          <div ref="questions-slider" class="sly">
            <div class="slider-number">
              <div
                v-for="(question, index) of questions"
                :class="{ passed: !!getAnsweredQuestionByIndex(index), 'active-item': index === currentQuestionIndex }"
                :key="index"
                class="slider-number__item"
                @click="goToQuestion(index)"
              >{{ index + 1 }}</div>
            </div>
          </div>

          <div class="sly-arrow"></div>
        </div>

        <div class="ticket-question__image">
          <img v-if="currentQuestion && currentQuestion.image" :src="`${$APP_URL}/storage/${currentQuestion.image}`" class="mb-3 w-100"/>
        </div>

        <div v-if="currentQuestion" class="ticket-question">
          <div class="ticket-number">Вопрос {{ currentQuestionIndex + 1 }}</div>
          <div class="timer">{{ timeFromSeconds }}</div>
          <div class="h3" v-html="currentQuestion.text"></div>
        </div>

        <form>
          <div
            v-for="(answer, key, index) in getAnswersOfQuestion(currentQuestion)"
            :key="index"
            class="checkout-group"
            :class="getAnswerClass(key, currentQuestionIndex)"
          >
            <input @click="answerOnQuestion(key)" type="radio" name="checkout-radio" :id="index" class="checkout-group__input">
            <label :for="index" class="checkout-group__label">
              <span>{{ index + 1 }}</span>
              <div class="checkout-group__text">{{ answer }}</div>
            </label>
          </div>
        </form>
        <!--        {{ currentQuestion.correct_answer }}-->
      </div>
    </div>

    <div v-if="currentExamResult && questions.length">
      <div class="tab">
        <div class="tab__header">
          <div class="tab__title h2">Экзамен {{ !currentExamResult.passed ? 'Не' : '' }} сдан!</div>
        </div>

        <div class="flex flex-justify-sb result">
          <div class="result-item"><span><span class="green">
            {{ currentExamResult.right }}</span>/{{ currentExamResult.questions }}</span> правильных ответов
          </div>
          <div class="result-item">Затраченное время: {{ elapsedTimeFormat }}</div>
          <div class="result-item">{{ currentExamResult.wrong }} Ошибок в билете </div>
        </div>

        <div class="result-link">
          <button type="button" @click="reloadQuestions" class="btn btn-green">пройти еще раз</button>
          <router-link to="/pdd/exams">Перейти к списку экзаменов</router-link>
        </div>
      </div>


      <div v-if="wrongAnswers.length > 0" class="h3 title text-center">Ваши ошибки</div>

      <div class="wrong" v-for="question of wrongAnswers" :key="question.index">
        <div class="wrong-header">
          <div class="wrong-number">Вопрос {{ question.index }}</div>
          <div class="wrong-question" v-html="question.question.text"></div>
          <div class="wrong-btn js-wrong-btn" data-open="close">Показать</div>
        </div>

        <img v-if="question.question.image" :src="`${$APP_URL}/storage/${question.question.image}`" class="wrong-img"/>

        <div class="wrong-block">
          <div class="answer"
               v-for="(answer, key, index) in question.answers"
               :key="index"
               :class="{ 'answer-right': question.question.correct_answer === key, 'answer-wrong': key === question.answer }"
          >
            <div class="answer-header">
              <div class="answer-number">{{ index + 1 }}</div>
              <div class="answer-title">{{ answer }}</div>
            </div>

            <div class="answer-info" v-if="question.question.correct_answer === key">
              <hr>
              <div class="text" v-html="question.question.comment"></div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div v-if="!questions.length" class="tab">
      <div class="result-link">
        <p>Нет вопросов к экзамену</p>
        <router-link to="/pdd/exams">Перейти к списку экзаменов</router-link>
      </div>
    </div>
  </div>
</template>

<script>
  import 'sly-scrolling/dist/sly';
  import { mapActions } from 'vuex';
  import mainMixin from '../../mixins/tests/main';

  export default {
    name: 'ConstructorQuestions',
    mixins: [mainMixin],
    data() {
      return {
        currentExamId: parseInt(this.$route.params.id, 10),
        currentQuestionIndex: null,
        currentExamResult: null,
        answeredQuestions: [],
        wrongAnswers: [],
        additionQuestionsAdded: false,
        additionQuestionsErrors: 0,
        timer: 1200,
        elapsedTime: 0,
        timerId: null,
        answeredQuestionsForProgress: {},
      };
    },
    computed: {
      questions() {
        return this.$store.getters.questions;
      },
      exams() {
        return this.$store.getters.collections;
      },
      constructors() {
        return this.$store.getters.constructors;
      },
      examName() {
        let examName = '';

        for (const exam of this.constructors) {
          if (exam.id === this.currentExamId) {
            examName = exam.name;
            break;
          }
        }

        return examName;
      },
      isQuestionAnswered() {
        return !!this.getAnswerOnCurrentQuestion();
      },
      isLastQuestionAnswered() {
        return this.answeredQuestions.length >= this.questions.length;
      },
      timeFromSeconds() {
        return (new Date(this.timer * 1000)).toTimeString().replace(/.*(\d{2}:\d{2}).*/, '$1');
      },
      elapsedTimeFormat() {
        return (new Date(this.elapsedTime * 1000)).toTimeString().replace(/.*(\d{2}:\d{2}).*/, '$1');
      },
    },
    methods: {
      ...mapActions('progress', ['setProgress']),
      getExamQuestions() {
        this.$store.dispatch('getConstructorQuestions', {
          id: this.currentExamId,
        })
          .then(() => {
            this.initExam();
          });
      },
      startTimer() {
        this.timerId = setInterval(() => {
          this.timer--;
          this.elapsedTime++;

          if (this.timer <= 0) {
            this.stopTimer();

            this.showExamResult();
          }
        }, 1000);
      },
      stopTimer() {
        clearInterval(this.timerId);
      },
      initExam() {
        this.currentQuestionIndex = 0;
        this.timer = this.questions.length * 60;

        this.initSly();
        this.startTimer();
      },
      getAnswersOfQuestion(question) {
        const answers = {};

        for (const prop in question) {
          if (/^answer\d+/.test(prop) && question[prop]) {
            answers[prop] = question[prop];
          }
        }

        return answers;
      },
      answerOnQuestion(answer) {
        const isWrongAnswer = answer !== this.currentQuestion.correct_answer;

        if (this.isQuestionAnswered) {
          return;
        }

        this.answeredQuestions.push({
          answer,
          index: this.currentQuestionIndex + 1,
          question: this.currentQuestion,
          answers: this.getAnswersOfQuestion(this.currentQuestion),
        });

        if (isWrongAnswer) {
          this.wrongAnswers.push(this.currentQuestion);

          if (this.additionQuestionsAdded) {
            this.additionQuestionsErrors++;
            this.showExamResult();
            return;
          }

          if (this.wrongAnswers.length >= 3) {
            this.showExamResult();
            return;
          }
        }

        const counts = this.answeredQuestions.reduce((acc, item) => {
          const isCorrect = item.answer === item.question.correct_answer;

          return {
            correct: acc.correct + (isCorrect ? 1 : 0),
            incorrect: acc.incorrect + (isCorrect ? 0 : 1),
          };
        }, { correct: 0, incorrect: 0 });

        const passed = (this.questions.length - counts.correct) <= 2;

        this.answeredQuestionsForProgress = {
          correct_answers: counts.correct,
          incorrect_answers: counts.incorrect,
          passed,
        };

        if (this.isLastQuestionAnswered) {
          this.showExamResult();
        }
      },
      showExamResult() {
        const questionsCount = this.questions.length;
        const wrongAnswers = this.wrongAnswers.length;
        let rightAnswers = 0;

        this.wrongAnswers = [];

        for (const [index, question] of this.questions.entries()) {
          const currentAnswer = this.getAnsweredQuestionByIndex(index);

          if (!!currentAnswer && currentAnswer.answer === question.correct_answer) {
            rightAnswers++;
          } else {
            const questionData = {
              answer: currentAnswer ? currentAnswer.answer : null,
              index: index + 1,
              answers: this.getAnswersOfQuestion(question),
              question,
            };

            this.wrongAnswers.push(questionData);
          }
        }

        const passed = (questionsCount - rightAnswers) <= 2;

        this.stopTimer();

        this.currentExamResult = {
          examId: parseInt(this.currentExamId, 10),
          questions: questionsCount,
          right: rightAnswers,
          wrong: wrongAnswers,
          errors: questionsCount - rightAnswers,
          time: this.timer,
          passed,
        };

        this.updateExamsResultsSettings();
        this.initResultDropdowns();
      },
      updateExamsResultsSettings() {
        let hasExamExist = false;

        for (let i = 0; i < this.$appSettings.constructorResults.length; i++) {
          const currentExam = this.$appSettings.constructorResults[i];

          hasExamExist = currentExam.examId === this.currentExamResult.examId;

          if (hasExamExist) {
            this.$appSettings.constructorResults.splice(i, 1);
            break;
          }
        }

        this.$appSettings.constructorResults.push(this.currentExamResult);
        this.updateAppSettings();
      },
      goToNextQuestion() {
        if (this.isTestDone) {
          return;
        }

        this.goToQuestion(this.getFirstUnansweredQuestionIndex(this.currentQuestionIndex));
      },
      reloadQuestions() {
        const nextR = this.$route.query.r ? parseInt(this.$route.query.r, 10) + 1 : 1;

        const query = {
          r: nextR,
        };

        if (this.$route.query.lesson_id) {
          query.lesson_id = this.$route.query.lesson_id;
        }
        if (this.$route.query.megapolis_token) {
          query.megapolis_token = this.$route.query.megapolis_token;
        }

        this.$router.push({
          path: `/pdd/constructors/${this.currentExamId}`,
          query: {
            r: this.$route.query.r ? parseInt(this.$route.query.r, 10) + 1 : 1,
          },
        });
      },
      getAnswerClass(key) {
        const isUserAnswer = this.isQuestionAnswered && key === this.getAnswerOnCurrentQuestion().answer;

        return {
          'answer-passed': isUserAnswer,
        };
      },
    },
    created() {
      this.getExamQuestions();

      if (!this.constructors.length) {
        this.$store.dispatch('getConstructors');
      }
    },
    beforeDestroy() {
      this.stopTimer();
    },
  };
</script>
